import React, { Component } from 'react'
import { checkTranslation, imageAddress, translate } from '../../utils/useful'
import ButtonAnimated from '../buttons/ButtonAnimated';
import HttpServices from '../../utils/Http.services';
import Modal from '../Modal';
import FormViewer from '../FormViewer';


export default class NotifConnectionRequestBox extends Component {
    state = {
        isLoadingHandle: {},
        data: {}
    }

    componentDidMount = () => {
        let data = this.props.data
        this.setState({ data })
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.data != this.props.data) {

            let data = this.props.data
            this.setState(data)

        }
    }


    handleRequest = (item, accept) => {

        let isLoadingHandle = this.state.isLoadingHandle ?? {}

        if (!isLoadingHandle[item._id]) {
            isLoadingHandle[item._id] = accept ? '1' : '0'
            this.setState({ isLoadingHandle })


            let data = { accept }

            if (item._id) {
                data.notif = item._id
            } else {
                data.notifRef = item.extra?.ref
            }

            console.log(data)

            HttpServices.request('handelRelationRequest', data, (fetchResult, fetchError) => {

                console.log(fetchResult, fetchError)

                isLoadingHandle[item._id] = null
                this.setState({ isLoadingHandle })

                if (fetchError) {
                    return
                }

                let data = this.state.data
                data.actionStatus = (accept ? 'A' : 'D')
                this.setState({ data })
            })


        }

    }

    openHub = (hub) => {
        this.props.addNewWindow("hub", { path: [hub?.username], type: 'applet' }, "center")
    }


    openFormInformation = (item) => {

        let currentFormInfo = item.form
        let currentFromFeilds = []

        if (item.connectionType?.form && item.connectionType?.form[0]?.pageContent) {
            item.connectionType?.form[0]?.pageContent.forEach(pageContent => {

                pageContent.sectionContent.forEach(sectionContent => {

                    sectionContent.rowContent.forEach(rowContent => {
                        rowContent.information.disabled = true
                        currentFromFeilds.push(rowContent)
                    });

                });


            });
        }

        this.setState({ currentFormInfo, currentFromFeilds }, () => {
            this.infoModal.showModal()
        })
    }



    render() {
        // let type = this.state.type
        let notif = this.state.data
        let isPopupMessange = this.props.isPopupMessange

        return (
            <div className="py-2 px-2 w-100">

                {!this.props.isInInput && (
                    <div className='flexc'>
                        <button onClick={() => this.openHub(notif?.sender)} className='flexc'>
                            <div className='flexcc mrd-1'>
                                <img src={imageAddress(notif?.sender?.image, 'profile', 'thumb')} height={32} width={32} className='br-20' style={{ border: '1px solid #eee' }} alt='' />
                            </div>
                        </button>

                        <div className='flexcc mrd-1'>
                            <img src={'/assets/icons/useful/link (4).png'} height={16} width={16} className='br-20 opacity-5' alt='' />
                        </div>

                        <button onClick={() => this.openHub(notif?.appletHub)} className='flexc'>
                            <div className='flexcc '>
                                <img src={imageAddress(notif?.appletHub?.image, 'profile', 'thumb')} height={32} width={32} className='br-20' style={{ border: '1px solid #eee' }} alt='' />
                            </div>
                        </button>
                    </div>
                )}

                {!this.props.isInInput && (

                    <div className='flexc mt-1'>
                        {/* <div className='flexcc mrd-2'>
                        <img src={imageAddress(notif?.sender?.image, 'profile', 'thumb')} height={26} width={26} className='br-20' alt='' />
                    </div> */}

                        <div className='text-start flexc'>

                            <button className='mrd-2' onClick={() => this.openHub(notif?.sender)}>
                                <p className="font-size-13 text-bold ">{checkTranslation(notif?.sender?.fullname)}</p>
                            </button>

                            <div className='flexcc mrd-2'>
                                <img src={'/assets/icons/useful/link (4).png'} height={16} width={16} className='br-20 opacity-5' alt='' />
                            </div>

                            <button onClick={() => this.openHub(notif?.hub)}>
                                <p className="font-size-13 text-bold">{checkTranslation(notif?.hub?.fullname)}</p>
                            </button>

                            {/* <p className="font-size-12">@{notif?.sender?.username}</p> */}
                        </div>
                    </div>
                )}

                {this.props.isInInput && (
                    <div className=' flexc'>

                        <button className=' flexc' onClick={() => this.openHub(notif?.sender)}>
                            <div className='flexcc mrd-2'>
                                <img src={imageAddress(notif?.hub?.image, 'profile', 'thumb')} height={32} width={32} className='br-20' style={{ border: '1px solid #eee' }} alt='' />
                            </div>
                            <p className="font-size-13 text-bold ">{checkTranslation(notif?.hub?.fullname)}</p>
                        </button>

                    </div>

                )}

                {/* <button onClick={() => this.openHub(notif?.appletHub)} className='flexc'>
                    <div className='flexcc mrd-2'>
                        <img src={imageAddress(notif?.appletHub?.image, 'profile', 'thumb')} height={20} width={20} className='br-20' alt='' />
                    </div>

                    <div className='text-start'>
                        <p className="font-size-12 text-semibold">{checkTranslation(notif?.appletHub?.fullname)}</p>
                        <p className="font-size-12">@{notif?.appletHub?.username}</p>
                    </div>
                </button> */}

                <div className='mt-1 '>
                    {notif?.message && (<p className=" text-semibold" style={{ fontSize: isPopupMessange ? 14 : 12 }}>{checkTranslation(notif.message)}</p>)}
                </div>

                {notif.connectionType && (
                    <div className="flexc font-size-13 mt-1">
                        <p className="text-semibold">{translate("Connection type")}</p>
                        <div className="flexcc mld-2">
                            <p className="font-size-12  br-20 px-2 py-1 text-semibold" style={{ backgroundColor: '#007aff20', color: '#007aff' }}>{notif.connectionType?.name}</p>
                        </div>
                    </div>
                )}

                {notif.form && (
                    <button onClick={() => this.openFormInformation(notif)}>
                        <p className="font-size-13 text-link">{translate("View form information")}</p>
                    </button>
                )}


                {Array.isArray(notif.groups) && notif.groups.filter((a) => !a.hidden).length > 0 && (
                    <div className="flexc mt-1">
                        {notif.groups.map((group, k) => {
                            if (!group.hidden) {
                                return (
                                    <div className="mrd-2 br-20 px-2 py-1 text-smaller" key={group._id} style={{ backgroundColor: '#007aff15', color: '#007aff' }}>
                                        <p>{group.name}</p>
                                    </div>
                                )
                            }
                        })}
                    </div>
                )}


                <div className={"mt-2 " + (isPopupMessange ? 'flexce' : 'flexc')}>

                    {notif.actionStatus == 'D' && (
                        <div className="br-20 px-3 py-2" style={{ color: '#ee5050', backgroundColor: "#ee505020" }}>
                            <p className={"text-semibold " + (isPopupMessange ? 'font-size-13' : 'font-size-12')}>{translate("Declined")}</p>
                        </div>

                    )}

                    {notif.actionStatus == 'A' && (
                        <div className="br-20 px-3 py-2" style={{ color: '#007aff', backgroundColor: "#007aff20" }}>
                            <p className={"text-semibold " + (isPopupMessange ? 'font-size-13' : 'font-size-12')}>{translate("Accepted")}</p>
                        </div>

                    )}

                    {notif.actionStatus == null && (
                        <div className='flexc'>
                            <div className="flexcc mrd-2">
                                <ButtonAnimated
                                    onClick={() => this.handleRequest(notif, false)}
                                    title={translate('Decline')}
                                    isLoading={this.state?.isLoadingHandle[notif._id] == '0'}
                                    textColor={'#777'}
                                    bg={'#e0e0e0'}
                                    fontSize={!isPopupMessange ? 12 : 14}
                                // width={'100%'}
                                />
                            </div>
                            <div className="flexcc">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.handleRequest(notif, true)}
                                    title={translate('Accept')}
                                    icon='/assets/icons/check-white.svg'
                                    textColor={'#fff'}
                                    fontSize={!isPopupMessange ? 12 : 14}
                                    isLoading={this.state?.isLoadingHandle[notif._id] == '1'}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                                />
                            </div>

                        </div>
                    )}
                </div>



                <Modal width={this.props.width} ref={el => this.infoModal = el} hideOverlay={false} maxWidth={400} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>


                    <div stage={0} stageName="List" className="w-100 br-10 pb-3 " style={{ backgroundColor: "white" }} >
                        <div className="d-flex flex-column px-3 pt-2 pb-2 top-0" style={{ borderRadius: '10px 10px 0px 0px', position: 'sticky', background: '#fff', borderBottom: '1px solid #eee' }}>
                            <p className="font-size-18 text-semibold py-1">{translate("From information")}</p>
                        </div>

                        <div className="pt-3">
                            <FormViewer ref={el => this.formInfo = el} headers={this.state.currentFromFeilds} initData={this.state.currentFormInfo} formClass={'bordered-form'} inputClass={'bordered-input '} variables={this.props.variables} />
                        </div>

                    </div>

                </Modal>

            </div>
        )
    }
}

